import { colors } from '@constants/colors';

export const useStyles = () => ({
  root: {
    color: colors.white,
    gap: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
  },
  text: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.02em',
  },
  divider: {
    flexGrow: 1,
    borderColor: colors.white_10,
  },
});
